<template>
  <div class="MeskenDokum">
    <div class="KFatura lazer" style="height: 50px" v-if="Hesap_id==6">
      <svg class="d-block" width="100%" height="16">
        <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="16"
              font-weight="bold">{{ Fatura.BinaAdi }}
        </text>
      </svg>
      <svg class="d-block" width="100%" height="16">
        <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="16"
              font-weight="bold">{{ Fatura.oBolge.toUpperCase() }}
        </text>
      </svg>
      <svg class="d-block" width="100%" height="16">
        <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="16"
              font-weight="bold">{{ Fatura.Sorumlu }}
        </text>
      </svg>

      <div class="sayfasonu"></div>
    </div>

    <LazerEFatura v-if="Fatura.eFaturaTutar" :Fatura="Fatura"></LazerEFatura>

    <div class="KFatura lazer" v-for="f in FaturaDokum">
      <div class="KFaturaIc">
        <div class="KHeader text-center">
          <div class="col-xs-12">
            <LazerHeaderLogo v-if="Hesap_id==6"></LazerHeaderLogo>
            <DorukLogo v-if="Hesap_id==7"></DorukLogo>
            <SerdarLogo v-if="Hesap_id==9"></SerdarLogo>
            <BesaLogo v-if="Hesap_id==12"></BesaLogo>
            <div v-if="Hesap_id>12">Lütfen Logo ayarlanması için bizimle iletişime geçiniz.</div>
          </div>

          <div class="clearfix"></div>
          <div class="KHeaderBilgi">
            <svg class="d-block" width="100%" height="18">
              <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="18"
                    font-weight="bold">{{ f.AdSoyad }}
              </text>
            </svg>
            <svg class="d-block" width="100%" height="10">
              <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="10" font-weight="bold">
                {{ Fatura.BinaAdi }}
              </text>
            </svg>
            <svg v-if="f.Grup" class="d-block" width="100%" height="10">
              <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="10" font-weight="bold">
                {{ f.Grup }}
              </text>
            </svg>
            <svg class="d-block" width="100%" height="10">
              <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="10">No: {{ f.kNo }} /
                {{ f.m2 }} m2
              </text>
            </svg>
            <svg class="d-block" width="100%" height="12">
              <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="12">
                {{ Fatura.aciklama }}
              </text>
            </svg>
            <svg class="d-block" width="100%" height="20">
              <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="12"
                    font-weight="bold">ELEKTRİK PAYLAŞIM BELGESİ
              </text>
            </svg>

          </div>
          <div class="KHeaderTutar">
            <div class="pull-left" style="width: 50%;padding: 5px">
              <svg width="100%" height="15" class="d-block">
                <text x="0" y="10" font-size="10" text-anchor="start"
                      font-weight="bold">ÖDENECEK TUTAR
                </text>
              </svg>
              <svg width="100%" height="22" class="d-block">
                <text x="0" y="18" font-size="20" text-anchor="start"
                      font-weight="bold">{{ f.Odenecek }}TL
                </text>
              </svg>
            </div>
            <div class="pull-right" style="width: 50%;padding: 5px">
              <svg width="100%" height="15" class="d-block">
                <text x="100%" y="10" font-size="10" text-anchor="end"
                      font-weight="bold">SON ÖDEME TARİHİ
                </text>
              </svg>
              <svg width="100%" height="22" class="d-block">
                <text x="100%" y="18" font-size="18" text-anchor="end"
                >{{ Fatura.starih }}
                </text>
              </svg>
            </div>
            <div class="clearfix"></div>
          </div>
          <table class="table table-xs table-bordered">
            <thead>
            <tr>
              <th colspan="2" class="text-center">
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-weight="bold" font-size="8" dominant-baseline="middle"
                        text-anchor="middle">GİDER DETAYLARI
                  </text>
                </svg>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="Fatura.Tur==1">
              <td :rowspan="Fatura.MuafPay?4:3" width="70px">
                <svg width="100%" height="20">
                  <text x="0" y="10" font-size="10" font-weight="bold" text-anchor="start">ISINMA</text>
                  <text x="0" y="20" font-size="10" font-weight="bold" text-anchor="start">GİDERLERİ</text>
                </svg>
              </td>
              <td>
                <svg class="pull-left" width="48%" height="10">
                  <text x="0" y="8" font-size="8" text-anchor="start" font-weight="bold">TÜKETİM BEDELİ</text>
                </svg>
                <svg class="pull-right" width="48%" height="10">
                  <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ f.tUcret }} TL</text>
                </svg>
              </td>
            </tr>
            <tr v-if="Fatura.Tur==1">
              <td>
                <svg class="pull-left" width="48%" height="10">
                  <text x="0" y="8" font-size="8" text-anchor="start" font-weight="bold">ORTAK ALAN BEDELİ</text>
                </svg>
                <svg class="pull-right" width="48%" height="10">
                  <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ f.oAlan }} TL</text>
                </svg>
              </td>
            </tr>
            <tr v-if="Fatura.MuafPay">
              <td>
                <svg class="pull-left" width="48%" height="10">
                  <text x="0" y="8" font-size="8" text-anchor="start" font-weight="bold">MUAF MESKEN PAYI</text>
                </svg>
                <svg class="pull-right" width="48%" height="10">
                  <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ f.MuafUcret }} TL</text>
                </svg>
              </td>
            </tr>

            <tr v-if="Fatura.SicakSu">

              <td>
                <svg class="pull-left" width="48%" height="10">
                  <text x="0" y="8" font-size="8" text-anchor="start" font-weight="bold">TÜKETİM BEDELİ</text>
                </svg>
                <svg class="pull-right" width="48%" height="10">
                  <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ f.sTuketim }} TL</text>
                </svg>
              </td>
            </tr>
            <tr v-if="f.SuOrtak">
              <td>
                <svg class="pull-left" width="48%" height="10">
                  <text x="0" y="8" font-size="8" text-anchor="start" font-weight="bold">ORTAK ALAN BEDELİ</text>
                </svg>
                <svg class="pull-right" width="48%" height="10">
                  <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ f.SuOrtak }} TL</text>
                </svg>
              </td>
            </tr>

            <tr>
              <td colspan="2">
                <svg class="pull-left" width="48%" height="10">
                  <text x="0" y="8" font-size="8" text-anchor="start" font-weight="bold">HİZMET BEDELİ</text>
                </svg>
                <svg class="pull-right" width="48%" height="10">
                  <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ f.Okuma }} TL</text>
                </svg>
              </td>
            </tr>
            <tr v-if="f.eTutar!='0.00'">
              <td colspan="2">
                <svg class="pull-left" width="48%" height="10">
                  <text x="0" y="8" font-size="8" text-anchor="start" font-weight="bold">{{ Fatura.eAciklama }}</text>
                </svg>
                <svg class="pull-right" width="48%" height="10">
                  <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ f.eTutar }} TL</text>
                </svg>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <svg class="pull-left" width="48%" height="10">
                  <text x="0" y="8" font-size="8" font-weight="bold" text-anchor="start">ALT TOPLAM</text>
                </svg>
                <svg class="pull-right" width="48%" height="10">
                  <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ f.Odenecek }} TL</text>
                </svg>
              </td>
            </tr>
            </tbody>
          </table>
          <table class="table table-xs table-bordered">
            <thead>
            <tr>
              <th colspan="5" class="text-center">
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-weight="bold" font-size="8"
                        dominant-baseline="middle"
                        text-anchor="middle">
                    SAYAÇ VE ENDEKS DETAYLARI
                  </text>
                </svg>
              </th>
            </tr>
            <tr>
              <th>
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-weight="bold" font-size="8" dominant-baseline="middle"
                        text-anchor="middle">
                    NO
                  </text>
                </svg>
              </th>

              <th>
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-weight="bold" font-size="8" dominant-baseline="middle"
                        text-anchor="middle">
                    İLK
                  </text>
                </svg>
              </th>
              <th >
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-weight="bold" font-size="8" dominant-baseline="middle"
                        text-anchor="middle">SON
                  </text>
                </svg>
              </th>
              <th>
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-weight="bold" font-size="8" dominant-baseline="middle"
                        text-anchor="middle">FARK
                  </text>
                </svg>
              </th>


            </tr>
            </thead>
            <tbody>

            <tr v-for="s in f.Sayac">
              <td>
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-size="8" dominant-baseline="middle" text-anchor="middle"
                        font-weight="bold">{{
                      s.SayacNo
                    }}
                  </text>
                </svg>
              </td>
              <td>
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-size="8" dominant-baseline="middle" text-anchor="middle"
                        font-weight="bold">
                    {{ s.Ilk }}kWh
                  </text>
                </svg>
              </td>
              <td >
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-size="8" dominant-baseline="middle" text-anchor="middle"
                        font-weight="bold">
                    {{ s.Son }}kWh
                  </text>
                </svg>
              </td>
              <td>
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-size="8" dominant-baseline="middle" text-anchor="middle"
                        font-weight="bold">
                    {{ s.Fark }}kWh
                  </text>
                </svg>
              </td>

            </tr>
            </tbody>
          </table>

          <table v-if="Fatura.dAciklama" class="table table-xs table-bordered">
            <thead>
            <tr>
              <th colspan="5" class="text-center">
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-weight="bold" font-size="8" dominant-baseline="middle"
                        text-anchor="middle">
                    {{ Fatura.dAciklama }}
                  </text>
                </svg>
              </th>
            </tr>
            </thead>
          </table>
          <table class="table table-xs table-bordered">
            <thead>
            <tr>
              <th colspan="3" class="text-center">
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-weight="bold" font-size="8" dominant-baseline="middle"
                        text-anchor="middle">
                    ELEKTRİK FATURA BİLGİLERİ
                  </text>
                </svg>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-right" width="50">
                <svg width="100%" height="10" class="d-block">
                  <text x="0%" y="8" font-size="8" font-weight="bold"
                        text-anchor="start">
                    ELEKTRİK FATURASI
                  </text>
                </svg>
                <svg width="100%" height="12">
                  <text x="0%" y="10" font-weight="bold" font-size="10"
                        text-anchor="start">
                    {{ Fatura.tutar }}TL
                  </text>
                </svg>
              </td>
              <td class="text-right" width="50">
                <svg width="100%" height="10" class="d-block">
                  <text x="0%" y="8" font-size="8" font-weight="bold"
                        text-anchor="start">
                    BİRİM FİYATI
                  </text>
                </svg>
                <svg width="100%" height="12">
                  <text x="0%" y="10" font-weight="bold" font-size="10"
                        text-anchor="start">
                    {{ Fatura.OnayBilgi.Birim  }}TL
                  </text>
                </svg>
              </td>


              <td class="text-right" width="50">

                <svg width="100%" height="10" class="d-block">
                  <text x="0%" y="8" font-size="8" font-weight="bold"
                        text-anchor="start">
                    ORTAK ALAN
                  </text>
                </svg>
                <svg width="100%" height="12">
                  <text x="0%" y="10" font-weight="bold" font-size="10"
                        text-anchor="start">
                    %{{ Fatura.oAlan }} - {{ AltToplam.oAlan }}TL
                  </text>
                </svg>
              </td>

            </tr>

            </tbody>
          </table>

          <svg width="100%" height="18" class="d-block">
            <text x="50%" y="12" font-size="12" font-weight="bold" text-anchor="middle">*** ÖDEMELERİ BİNA YÖNETİMİNE
              YAPINIZ ***
            </text>
          </svg>


          <svg v-if="Hesap_id==6" width="100%" height="12" class="d-block">
            <text x="50%" y="12" font-size="12" font-weight="bold" text-anchor="middle">TASARRUF TEDBİRLERİ VE DUYURULAR
              İÇİN
            </text>
            ,
          </svg>
          <svg v-if="Hesap_id==6" width="100%" height="18" class="d-block">
            <text x="50%" y="12" font-size="12" font-weight="bold" text-anchor="middle">INSTAGRAM HESABIMIZI TAKİP
              EDİN
            </text>
          </svg>
          <div class="clearfix"></div>
          <!--LazerReklam  v-if="Hesap_id==6"></LazerReklam-->

          <svg class="d-block" width="100%" height="16">
            <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="16" font-weight="bold">
              ABONE NO: {{ f.AboneNo }}
            </text>
          </svg>
          <svg width="100%" height="40" class="d-block" style="padding-top: 0px;">
            <text x="50%" y="20" font-size="50" class="barkodbaski" text-anchor="middle">
              {{ f.AboneNo }}
            </text>
          </svg>

        </div>

      </div>
      <div class="sayfasonu"></div>
    </div>
    <ArizaBildirimi v-if="Hesap_id==6" :FaturaDokum="FaturaDokum" :Fatura="Fatura" :AltToplam="AltToplam"
                    :Hesap_id="Hesap_id"></ArizaBildirimi>
  </div>
</template>

<script>
import LazerReklam from "./LazerReklam";
import LazerHeaderLogo from "./LazerHeaderLogo";
import DorukLogo from "./DorukLogo";
import SerdarLogo from "./SerdarLogo";
import LazerEFatura from "./LazerEFatura";
import LazerAltKisim from "./LazerAltKisim";
import ArizaBildirimi from "./ArizaBildirimi";
import BesaLogo from "./BesaLogo";

export default {
  components: {
    BesaLogo,
    ArizaBildirimi, LazerAltKisim, LazerEFatura, SerdarLogo, DorukLogo, LazerHeaderLogo, LazerReklam
  },
  props: ['FaturaDokum', 'Fatura', 'AltToplam', 'Hesap_id']
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Libre+Barcode+39&display=swap');

.MeskenDokum * {
  font-family: 'IBM Plex Sans', sans-serif !important;

}

.barkod {
  width: 100%;
  display: block;
  height: 80px;
}

.barkod div {
  display: inline-block;
  float: left;
}

.barkodbaski {
  font-family: 'Libre Barcode 39', cursive !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pack/Esayac/ElektrikLazer.vue